export const translations = {
  en: {
    common: {
      views: 'views',
      subscribed: 'Subscribed!',
      subscribedMessage: 'Thank you for subscribing to our newsletter.',
      songExample: 'For My Clara',
      totalPrice: 'Total Price:',
      uploadPhoto: 'Upload Photo',
      uploaded: 'Uploaded',
      addPhotoButton: 'Add Another Photo (Max 10)',
      minPhotosWarning: 'Minimum 3 photos required for AI CLIP',
      photoSlot: 'Photo',
      fileFormat: 'JPG, PNG or HEIC (Max 10MB)',
      whatYouGet: 'What you\'ll get: A 30-60 second AI-generated video combining your photos with the song, perfect for social media sharing!',
      nameOrNamesPlaceholder: 'Name or names...',
      relationshipPlaceholder: 'My son, my daughter, my best friend...',
      occasionPlaceholder: 'Birthday, Wedding, Retirement...',
      phrasePlaceholder: 'Your symbolic phrase...',
      verses2Free: '2 Verses (Free)',
      verses3: '3 Verses (+$3.90)',
      verses4: '4 Verses (+$6.90)'
    },
    nav: {
      home: 'Home',
      create: 'Create Your Song',
      examples: 'Examples',
      reviews: 'Reviews',
      story: 'Our Story',
      artists: 'Meet Our Artists',
      contact: 'Contact Us'
    },
    hero: {
      badge: 'Your song at -50% today',
      reviewsBadge: '1582 Verified Reviews | +10,000 Songs Created',
      mainTitle: 'Give the gift of emotion in music',
      mainSubtitle: 'A 100% original song, created from your story',
      ctaButton: 'Create a personalized song',
      priceText: 'Personalized song + QR code + YouTube:',
      price: '$39.90',
      originalPrice: '$70.00',
      discount: '-50% today!'
    },
    form: {
      title: 'Personalize Your Song',
      quickBadge: '✨ Order in just 4 minutes',
      subtitle: 'Answer the questions below and we will create a unique song, just for you.',
      required: 'Required fields are marked with *',
      whoFor: 'Who is this song for?',
      whoForHelp: 'The song can be dedicated to multiple people! Enter their names here.',
      relationship: 'Your relationship with this person',
      relationshipHelp: 'Specify your relationship: my son, my daughter, my mom, my dad, my husband, my wife, my best friend...',
      occasion: 'Is it for a special occasion?',
      occasionHelp: 'No need for a special occasion! But if it\'s for a birthday, retirement, wedding, or birth, specify it.',
      occasionNo: 'No',
      tellUs: 'Tell us about this person',
      tellUsHelp: 'This is the most important part! Tell us who this person is, what you love about them, a strong memory, their passions...',
      tellUsPlaceholder: 'A memory, a quality, a joke, a special moment... The more details you share, the more the song will truly reflect them.',
      styleTitle: 'Style & Ambiance',
      language: 'Song Language',
      languageHelp: 'The song will be entirely sung in the chosen language.',
      selectLanguage: 'Select a language',
      musicalStyle: 'Musical Style',
      musicalStyleHelp: 'Choose the style that matches the recipient\'s taste.',
      selectStyle: 'Select a musical style',
      era: 'Era / Years',
      selectEra: 'Select an era',
      ambiance: 'Music Ambiance',
      ambianceHelp: 'The ambiance defines the emotional tone of the song.',
      selectAmbiance: 'Select an ambiance',
      voice: 'Artist Voice',
      voiceHelp: 'Standard structure: Verse 1 / Chorus / Verse 2 / Chorus. Duo combines male and female voice.',
      voiceMale: 'Male',
      voiceFemale: 'Female',
      voiceDuo: 'Duo',
      options: 'Options',
      verses: 'Number of Verses',
      versesHelp: 'Each additional verse enriches the story.',
      phrase: 'Add a symbolic phrase',
      phraseHelp: 'The phrase you write will be integrated word for word into the song.',
      streaming: 'Add your song to streaming platforms?',
      streamingHelp: 'Your song will be available on Spotify, Apple Music, Deezer, and more.',
      streamingNo: 'No, MP3 is enough',
      streamingYes: 'Yes',
      delivery: 'Delivery Time',
      deliveryStandard: 'Standard – 48h (Free)',
      deliveryExpress: 'Express – 24h',
      deliveryPriority: 'Priority – 12h',
      photo: 'Add a photo to the song',
      photoHelp: 'Your photo will be integrated as the cover on your MP3 file.',
      photoNo: 'No',
      voiceRecording: 'Add your voice to the song',
      voiceRecordingHelp: 'Record a personal message, dedication, or sing along! Your voice will be integrated into the song.',
      voiceRecordingNo: 'No',
      voiceRecordingYes: 'Yes, record my voice',
      voiceOwner: 'Whose voice is this?',
      voiceOwnerPlaceholder: 'Name of the person...',
      voiceRecordVoice1: 'Voice 1',
      voiceRecordVoice2: 'Voice 2',
      voiceRecordDuoNote: 'Since you selected Duo, you can record 2 voices',
      voiceRecordStart: 'Start Recording',
      voiceRecordStop: 'Stop Recording',
      voiceRecordPlay: 'Play Recording',
      voiceRecordReRecord: 'Re-record',
      voiceRecordingTime: 'Recording',
      voiceRecordMaxDuration: 'Max 60 seconds',
      voiceRecordInstructions: 'Click "Start Recording" and speak your message. You can record up to 60 seconds.',
      voiceRecordSuccess: 'Voice recorded successfully!',
      aiClip: 'Add AI Video CLIP',
      aiClipHelp: 'Create a personalized video with photos of your loved ones and an AI-generated scenario. Perfect for sharing on social media!',
      aiClipNo: 'No, song only',
      aiClipYes: 'Yes, create AI video',
      aiClipPhotos: 'Upload photos for the video',
      aiClipPhotosHelp: 'Add 3-10 photos that will be used in your AI video clip',
      aiClipPhotoName: 'Who is in this photo?',
      aiClipPhotoNamePlaceholder: 'Name of the person(s)...',
      aiClipScenario: 'Describe the video scenario',
      aiClipScenarioHelp: 'Tell us what story you want the video to tell (a journey, special moments, evolution over time...)',
      aiClipScenarioPlaceholder: 'Example: A montage of childhood to present, our best vacation moments, a love story timeline...',
      email: 'Your Email Address',
      emailHelp: 'We will send your song to this email address',
      emailPlaceholder: 'your.email@example.com',
      deliveryInfo: 'Delivery Time Information',
      deliveryStandard8h: 'Without AI CLIP: 8 hours',
      deliveryWithClip16h: 'With AI CLIP: 16 hours',
      proceedToPayment: 'Proceed to Payment',
      securePayment: '🔒 100% Secure Payment',
      orderNow: 'Order now to guarantee processing by our artists'
    },
    delivery: {
      title: 'Fast Delivery',
      description: 'All orders are delivered within 48 hours. If you\'re in a hurry, you can choose an express delivery option to receive your song in 12 or 24 hours.'
    },
    receive: {
      title: 'What You Receive',
      description: 'Your song will be sent to you by email in MP3 format, accompanied by the lyrics in PDF. If you choose the streaming option, the song will also be available on music platforms.'
    },
    guarantees: {
      title: 'Our Guarantees',
      unlimited: 'Unlimited Revisions',
      unlimitedDesc: 'We adjust the song as many times as necessary until it pleases you.',
      satisfaction: 'Satisfaction Guaranteed or Refund',
      satisfactionDesc: 'If despite the revisions, no version satisfies you, we proceed with a refund.',
      fast: 'Fast Delivery',
      fastDesc: 'Your song is delivered within 48 hours (or faster with options).',
      free: 'Free Usage',
      freeDesc: 'You can listen, share, and gift your song freely.'
    },
    howItWorks: {
      title: 'How It Works?',
      step1: 'Fill out the form',
      step1Desc: 'Tell us about the person and choose the musical style',
      step2: 'Our artists create',
      step2Desc: 'Your personalized song is composed and recorded',
      step3: 'Receive & enjoy',
      step3Desc: 'Get your song by email in 12-48h'
    },
    testimonials: {
      badge: 'Video Testimonials',
      title: 'Their Reactions on Video',
      titleHighlight: 'Reactions',
      lived: 'They lived it, they shared it.',
      subtitle: 'Discover the authentic emotion of those who have given or received a personalized song. Unforgettable moments captured on video.',
      playing: 'Now playing...',
      listen: 'Listen to the song',
      ctaTitle: 'You too, create an unforgettable moment',
      ctaTitleHighlight: 'unforgettable',
      ctaSubtitle: 'Join thousands of people who have touched hearts with a personalized song',
      ctaButton: 'Start Your Song'
    },
    examples: {
      title: 'Listen to Some Song Examples',
      subtitle: 'These examples allow you to discover the musical style. Your song will then be created especially for you, with unlimited revisions until satisfaction.'
    },
    platforms: {
      title: 'Find Your Song On'
    },
    artists: {
      title: 'Our Multilingual Artists',
      description: 'Artists selected for their musical sensitivity and their ability to tell stories in song, in English, French, Spanish, and Italian.',
      stat1: '100% Authentic Creation',
      stat2: '+10,000 Unique Songs Delivered',
      stat3: '+15 Years of Musical Excellence'
    },
    why: {
      title: 'Why Our Customers Love Us',
      quality: 'Professional Quality',
      qualityDesc: 'Each song is created with the same requirements as a real studio title. Our artists use professional tools to guarantee impeccable sound quality.',
      personalization: 'Complete Personalization',
      personalizationDesc: 'Lyrics, melody, style, voice... Everything is designed to tell your story, with a song that resembles no other.',
      speed: 'Delivery Speed',
      speedDesc: 'Thanks to an optimized process, your song is created quickly, without compromise on quality. Ideal for a last-minute gift.',
      unique: 'Unique and Memorable Gift',
      uniqueDesc: 'Offering a personalized song is offering an emotion. A memory that we listen to, share, and cherish for years.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'Are my personal information protected?',
      a1: 'Absolutely. Respect for your privacy is a priority. All information you share is strictly confidential and used only for creating your personalized song.',
      q2: 'How long does it take to receive my personalized song?',
      a2: 'Our team of artists commits to delivering your song in less than 48 hours. If you choose a priority delivery option, your song can be ready in 12 or 24 hours.',
      q3: 'How will I receive my song?',
      a3: 'Your song will be sent to you by email, in high-quality MP3 format, ready to be listened to, downloaded, and shared. If you chose the broadcast option, it will also be available on the main streaming platforms.',
      q4: 'Can I choose the musical style of my song?',
      a4: 'Yes, of course. You can choose the musical style, ambiance, and type of voice you want. We offer a wide variety of genres to best match the tastes of the person the song is for.',
      q5: 'What happens if I don\'t like the song?',
      a5: 'Your satisfaction is our priority. If the first version of your song does not fully meet your expectations, you benefit from included revisions to adjust the result until it suits you. And if despite the revisions, no version satisfies you, we simply proceed with a refund.',
      q6: 'Is there a limit to the number of listens of my song?',
      a6: 'No limit. Once your song is delivered, it belongs to you entirely. You can listen to it as many times as you want, keep it for life, and share it with your loved ones, without any restriction.'
    },
    newsletter: {
      title: 'Join Our Musical Newsletter',
      description: 'Enter your email to stay informed of news and benefit from exclusive offers.',
      placeholder: 'Email',
      button: 'Subscribe'
    },
    legal: {
      lastUpdated: 'Last Updated',
      updateDate: 'January 2025',
      contact: {
        title: 'Contact Us'
      },
      terms: {
        title: 'Terms & Conditions',
        section1: {
          title: '1. Acceptance of Terms',
          content: 'By accessing and using TRAKZSTUDIO services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.'
        },
        section2: {
          title: '2. Service Description',
          content: 'TRAKZSTUDIO provides custom song creation services. Our service includes:',
          item1: 'Creation of a personalized song based on your specifications',
          item2: 'Professional audio production and mixing',
          item3: 'Digital delivery via email and YouTube',
          item4: 'QR code for easy sharing'
        },
        section3: {
          title: '3. Payment Terms',
          content: 'Payment is required in full before work begins on your custom song. We accept major credit cards through Stripe. All prices are in USD and include applicable taxes.'
        },
        section4: {
          title: '4. Intellectual Property',
          content: 'Upon full payment, you receive a personal, non-exclusive license to use the custom song. TRAKZSTUDIO retains all intellectual property rights to the composition and production techniques.'
        },
        section5: {
          title: '5. Delivery Timeline',
          content: 'Standard delivery time is 5-7 business days from order confirmation. Express delivery options are available for an additional fee. Delivery times are estimates and may vary based on order complexity.'
        },
        section6: {
          title: '6. Limitation of Liability',
          content: 'TRAKZSTUDIO is not liable for any indirect, incidental, or consequential damages arising from the use of our services. Our total liability is limited to the amount paid for the service.'
        }
      },
      privacy: {
        title: 'Privacy Policy',
        section1: {
          title: '1. Information We Collect',
          content: 'We collect personal information you provide when ordering a custom song, including your name, email address, payment information, and the details needed to create your personalized song.'
        },
        section2: {
          title: '2. How We Use Your Information',
          content: 'We use your information to:',
          item1: 'Create and deliver your custom song',
          item2: 'Process payments and send order confirmations',
          item3: 'Communicate with you about your order',
          item4: 'Send promotional emails (with your consent)'
        },
        section3: {
          title: '3. Data Security',
          content: 'We implement industry-standard security measures to protect your personal information. Payment processing is handled securely through Stripe, and we do not store credit card information on our servers.'
        },
        section4: {
          title: '4. Third-Party Services',
          content: 'We use third-party services including Stripe (payment processing), Airtable (order management), and YouTube (content delivery). These services have their own privacy policies.'
        },
        section5: {
          title: '5. Your Rights',
          content: 'You have the right to access, correct, or delete your personal information. You may also opt out of marketing communications at any time by contacting us.'
        },
        section6: {
          title: '6. Cookie Policy',
          content: 'We use cookies to improve your experience on our website. You can control cookie settings through your browser preferences.'
        }
      },
      refund: {
        title: 'Return & Refund Policy',
        section1: {
          title: '1. Satisfaction Guarantee',
          content: 'We are committed to your satisfaction. If you are not completely satisfied with your custom song, please contact us within 7 days of delivery.'
        },
        section2: {
          title: '2. Revision Policy',
          content: 'Each order includes one round of minor revisions at no additional cost. Revisions must be requested within 7 days of initial delivery and are limited to lyrical adjustments or minor production changes.'
        },
        section3: {
          title: '3. Refund Eligibility',
          content: 'Refunds may be issued in cases where we are unable to deliver a song that meets the specifications provided in your order. Refund requests must be submitted within 14 days of the original delivery date.'
        },
        section4: {
          title: '4. Non-Refundable Items',
          content: 'Due to the custom nature of our service, refunds are not available once you have approved the final song. Express delivery fees and additional verse charges are also non-refundable.'
        },
        section5: {
          title: '5. Refund Process',
          content: 'Approved refunds will be processed within 5-10 business days and credited to the original payment method. Please allow additional time for your financial institution to process the refund.'
        },
        section6: {
          title: '6. Cancellation Policy',
          content: 'Orders may be cancelled within 24 hours of placement for a full refund. After 24 hours, cancellations are subject to a 30% processing fee if work has already begun.'
        }
      }
    },
    trustpilot: {
      title: 'Loved by',
      titleHighlight: 'Thousands',
      description: 'Real reviews from real customers who experienced the magic of personalized music',
      seeAllReviews: 'See all reviews on'
    },
    footer: {
      service: 'Customer Service',
      menu: 'Menu',
      info: 'Information',
      contact: 'Contact by email Monday to Sunday from 9am to 8pm for a quick response!',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      refund: 'Return & Refund Policy',
      legal: 'Legal Notices'
    }
  },
  fr: {
    common: {
      views: 'vues',
      subscribed: 'Inscrit !',
      subscribedMessage: 'Merci de vous être inscrit à notre newsletter.',
      songExample: 'Pour ma Clara',
      totalPrice: 'Prix Total :',
      uploadPhoto: 'Télécharger une Photo',
      uploaded: 'Téléchargé',
      addPhotoButton: 'Ajouter une Autre Photo (Max 10)',
      minPhotosWarning: 'Minimum 3 photos requises pour le CLIP IA',
      photoSlot: 'Photo',
      fileFormat: 'JPG, PNG ou HEIC (Max 10MB)',
      whatYouGet: 'Ce que vous obtenez : Une vidéo de 30-60 secondes générée par IA combinant vos photos avec la chanson, parfait pour partager sur les réseaux sociaux !',
      nameOrNamesPlaceholder: 'Nom ou noms...',
      relationshipPlaceholder: 'Mon fils, ma fille, mon meilleur ami...',
      occasionPlaceholder: 'Anniversaire, Mariage, Retraite...',
      phrasePlaceholder: 'Votre phrase symbolique...',
      verses2Free: '2 Couplets (Gratuit)',
      verses3: '3 Couplets (+3,90€)',
      verses4: '4 Couplets (+6,90€)'
    },
    nav: {
      home: 'Accueil',
      create: 'Créer votre chanson',
      examples: 'Exemples',
      reviews: 'Avis',
      story: 'Notre histoire',
      artists: 'Rejoindre nos artistes',
      contact: 'Nous contacter'
    },
    hero: {
      badge: 'Votre chanson à -50% aujourd\'hui',
      reviewsBadge: '1582 Avis vérifiés | +10 000 Chansons créées',
      mainTitle: 'Offrez l\'émotion en musique',
      mainSubtitle: 'Une chanson 100% originale, créée à partir de votre histoire',
      ctaButton: 'Créer une chanson personnalisée',
      priceText: 'Chanson personnalisée + QR code + YouTube :',
      price: '39,90€',
      originalPrice: '70,00€',
      discount: '-50% aujourd\'hui !'
    },
    form: {
      title: 'Personnalisez votre chanson',
      quickBadge: '✨ Commandez en 4 minutes chrono',
      subtitle: 'Répondez aux questions ci-dessous et nous créerons une chanson unique, rien que pour vous.',
      required: 'Les champs marqués d\'un * sont obligatoires',
      whoFor: 'Pour qui est cette chanson ?',
      whoForHelp: 'La chanson peut être dédiée à plusieurs personnes ! Indiquez leurs prénoms ici.',
      relationship: 'Votre lien avec cette personne',
      relationshipHelp: 'Précisez votre relation : mon fils, ma fille, ma maman, mon papa, mon mari, ma femme, mon meilleur ami...',
      occasion: 'Est-ce pour une occasion particulière ?',
      occasionHelp: 'Pas besoin d\'une occasion spéciale ! Mais si c\'est pour un anniversaire, une retraite, un mariage, précisez-le.',
      occasionNo: 'Non',
      tellUs: 'Parlez-nous de cette personne',
      tellUsHelp: 'C\'est la partie la plus importante ! Racontez qui est cette personne, ce que vous aimez chez elle, un souvenir fort...',
      tellUsPlaceholder: 'Un souvenir, une qualité, une blague, un moment fort... Plus vous partagez de détails, plus la chanson lui ressemblera vraiment.',
      styleTitle: 'Style & Ambiance',
      language: 'Langue de la chanson',
      languageHelp: 'La chanson sera entièrement chantée dans la langue choisie.',
      selectLanguage: 'Choisissez une langue',
      musicalStyle: 'Style musical',
      musicalStyleHelp: 'Choisissez le style qui correspond au goût du destinataire.',
      selectStyle: 'Choisissez un style musical',
      era: 'Époque / Années',
      selectEra: 'Choisissez une époque',
      ambiance: 'Ambiance de la musique',
      ambianceHelp: 'L\'ambiance définit le ton émotionnel de la chanson.',
      selectAmbiance: 'Choisissez une ambiance',
      voice: 'Voix de l\'artiste',
      voiceHelp: 'Structure standard : Couplet 1 / Refrain / Couplet 2 / Refrain. Le Duo associe une voix masculine et féminine.',
      voiceMale: 'Homme',
      voiceFemale: 'Femme',
      voiceDuo: 'Duo',
      options: 'Options',
      verses: 'Nombre de couplets',
      versesHelp: 'Chaque couplet supplémentaire enrichit l\'histoire.',
      phrase: 'Ajouter une phrase symbolique',
      phraseHelp: 'La phrase que vous écrivez sera intégrée mot pour mot dans la chanson.',
      streaming: 'Ajouter votre chanson sur les plateformes de streaming ?',
      streamingHelp: 'Votre chanson sera diffusée sur Spotify, Apple Music, Deezer et bien d\'autres.',
      streamingNo: 'Non, le MP3 me suffit',
      streamingYes: 'Oui',
      delivery: 'Délai de livraison',
      deliveryStandard: 'Standard – 48h (Gratuit)',
      deliveryExpress: 'Express – 24h',
      deliveryPriority: 'Priorité – 12h',
      photo: 'Ajouter une photo à la chanson',
      photoHelp: 'Votre photo sera intégrée comme pochette sur votre fichier MP3.',
      photoNo: 'Non',
      voiceRecording: 'Ajouter votre voix dans la chanson',
      voiceRecordingHelp: 'Enregistrez un message personnel, une dédicace, ou chantez avec ! Votre voix sera intégrée dans la chanson.',
      voiceRecordingNo: 'Non',
      voiceRecordingYes: 'Oui, enregistrer ma voix',
      voiceOwner: 'À qui appartient cette voix ?',
      voiceOwnerPlaceholder: 'Nom de la personne...',
      voiceRecordVoice1: 'Voix 1',
      voiceRecordVoice2: 'Voix 2',
      voiceRecordDuoNote: 'Comme vous avez sélectionné Duo, vous pouvez enregistrer 2 voix',
      voiceRecordStart: 'Démarrer l\'enregistrement',
      voiceRecordStop: 'Arrêter l\'enregistrement',
      voiceRecordPlay: 'Écouter l\'enregistrement',
      voiceRecordReRecord: 'Ré-enregistrer',
      voiceRecordingTime: 'Enregistrement',
      voiceRecordMaxDuration: 'Max 60 secondes',
      voiceRecordInstructions: 'Cliquez sur "Démarrer l\'enregistrement" et parlez votre message. Vous pouvez enregistrer jusqu\'à 60 secondes.',
      voiceRecordSuccess: 'Voix enregistrée avec succès !',
      aiClip: 'Ajouter un CLIP Vidéo IA',
      aiClipHelp: 'Créez une vidéo personnalisée avec les photos de vos proches et un scénario généré par IA. Parfait pour partager sur les réseaux sociaux !',
      aiClipNo: 'Non, chanson uniquement',
      aiClipYes: 'Oui, créer la vidéo IA',
      aiClipPhotos: 'Uploadez les photos pour la vidéo',
      aiClipPhotosHelp: 'Ajoutez 3 à 10 photos qui seront utilisées dans votre clip vidéo IA',
      aiClipPhotoName: 'Qui est sur cette photo ?',
      aiClipPhotoNamePlaceholder: 'Nom de la/des personne(s)...',
      aiClipScenario: 'Décrivez le scénario de la vidéo',
      aiClipScenarioHelp: 'Dites-nous quelle histoire vous voulez que la vidéo raconte (un voyage, moments spéciaux, évolution dans le temps...)',
      aiClipScenarioPlaceholder: 'Exemple : Un montage de l\'enfance à aujourd\'hui, nos meilleurs moments de vacances, une chronologie d\'amour...',
      email: 'Votre Adresse Email',
      emailHelp: 'Nous enverrons votre chanson à cette adresse email',
      emailPlaceholder: 'votre.email@exemple.com',
      deliveryInfo: 'Informations de Délai',
      deliveryStandard8h: 'Sans CLIP IA : 8 heures',
      deliveryWithClip16h: 'Avec CLIP IA : 16 heures',
      proceedToPayment: 'Procéder au Paiement',
      securePayment: '🔒 Paiement 100% Sécurisé',
      orderNow: 'Commandez maintenant pour garantir votre prise en charge par nos artistes'
    },
    delivery: {
      title: 'Livraison rapide',
      description: 'Toutes les commandes sont livrées sous 48 heures. Si vous êtes pressé, vous pouvez choisir une option de livraison express pour recevoir votre chanson en 12 ou 24 heures.'
    },
    receive: {
      title: 'Ce que vous recevez',
      description: 'Votre chanson vous sera envoyée par e-mail au format MP3, accompagnée des paroles en PDF. Si vous choisissez l\'option streaming, la chanson sera également disponible sur les plateformes de musique.'
    },
    guarantees: {
      title: 'Nos garanties',
      unlimited: 'Retouches illimitées',
      unlimitedDesc: 'Nous ajustons la chanson autant de fois que nécessaire, jusqu\'à ce qu\'elle vous plaise.',
      satisfaction: 'Satisfaction garantie ou remboursé',
      satisfactionDesc: 'Si malgré les retouches, aucune version ne vous satisfait, nous procédons à un remboursement.',
      fast: 'Livraison rapide',
      fastDesc: 'Votre chanson est livrée sous 48 heures (ou plus rapidement avec les options).',
      free: 'Utilisation libre',
      freeDesc: 'Vous pouvez écouter, partager et offrir votre chanson librement.'
    },
    howItWorks: {
      title: 'Comment ça marche ?',
      step1: 'Remplissez le formulaire',
      step1Desc: 'Parlez-nous de la personne et choisissez le style musical',
      step2: 'Nos artistes créent',
      step2Desc: 'Votre chanson personnalisée est composée et enregistrée',
      step3: 'Recevez & profitez',
      step3Desc: 'Recevez votre chanson par email sous 12-48h'
    },
    testimonials: {
      badge: 'Témoignages Vidéo',
      title: 'Leurs Réactions en Vidéo',
      lived: 'Ils l\'ont vécu, ils l\'ont partagé.',
      subtitle: 'Découvrez l\'émotion authentique de ceux qui ont offert ou reçu une chanson personnalisée. Des moments inoubliables capturés en vidéo.',
      playing: 'En cours de lecture...',
      listen: 'Écouter la chanson',
      ctaTitle: 'Vous aussi, créez un moment inoubliable',
      ctaSubtitle: 'Rejoignez des milliers de personnes qui ont touché des cœurs avec une chanson personnalisée',
      ctaButton: 'Commencer Votre Chanson'
    },
    examples: {
      title: 'Écoutez quelques exemples de chansons',
      subtitle: 'Ces exemples permettent de découvrir le style musical. Votre chanson sera ensuite créée spécialement pour vous, avec retouches illimitées jusqu\'à satisfaction.'
    },
    platforms: {
      title: 'Retrouvez votre chanson sur'
    },
    artists: {
      title: 'Nos artistes multilingues',
      description: 'Des artistes sélectionnés pour leur sensibilité musicale et leur capacité à raconter des histoires en chanson, en français, anglais, espagnol et italien.',
      stat1: '100% Création authentique',
      stat2: '+10 000 Chansons uniques livrées',
      stat3: '+15 ans d\'excellence musicale'
    },
    why: {
      title: 'Pourquoi nos clients nous adorent',
      quality: 'Qualité professionnelle',
      qualityDesc: 'Chaque chanson est créée avec les mêmes exigences qu\'un véritable titre de studio. Nos artistes utilisent des outils professionnels pour garantir une qualité sonore irréprochable.',
      personalization: 'Personnalisation complète',
      personalizationDesc: 'Paroles, mélodie, style, voix... Tout est pensé sur mesure pour raconter votre histoire, avec une chanson qui ne ressemble à aucune autre.',
      speed: 'Rapidité de livraison',
      speedDesc: 'Grâce à un processus optimisé, votre chanson est créée rapidement, sans compromis sur la qualité. Idéal pour un cadeau de dernière minute.',
      unique: 'Cadeau unique et mémorable',
      uniqueDesc: 'Offrir une chanson personnalisée, c\'est offrir une émotion. Un souvenir que l\'on réécoute, partage et chérit pendant des années.'
    },
    faq: {
      title: 'Questions récurrentes',
      q1: 'Mes informations personnelles sont-elles protégées ?',
      a1: 'Absolument. Le respect de votre vie privée est une priorité. Toutes les informations que vous partagez sont strictement confidentielles et utilisées uniquement pour la création de votre chanson personnalisée.',
      q2: 'Combien de temps faut-il pour recevoir ma chanson personnalisée ?',
      a2: 'Notre équipe d\'artistes s\'engage à livrer votre chanson en moins de 48 heures. Si vous choisissez une option de livraison prioritaire, votre chanson peut être prête en 12 ou 24 heures.',
      q3: 'Comment vais-je recevoir ma chanson ?',
      a3: 'Votre chanson vous sera envoyée par email, au format MP3 haute qualité, prête à être écoutée, téléchargée et partagée. Si vous avez choisi l\'option diffusion, elle sera également disponible sur les principales plateformes de streaming.',
      q4: 'Puis-je choisir le style musical de ma chanson ?',
      a4: 'Oui, bien sûr. Vous pouvez choisir le style musical, l\'ambiance et le type de voix que vous souhaitez. Nous proposons une large variété de genres pour correspondre au mieux aux goûts de la personne à qui la chanson est destinée.',
      q5: 'Que se passe-t-il si je n\'aime pas la chanson ?',
      a5: 'Votre satisfaction est notre priorité. Si la première version de votre chanson ne correspond pas totalement à vos attentes, vous bénéficiez de révisions incluses pour ajuster le rendu jusqu\'à ce qu\'il vous convienne. Et si malgré les révisions, aucune version ne vous satisfait, nous procédons tout simplement à un remboursement.',
      q6: 'Y a-t-il une limite au nombre d\'écoutes de ma chanson ?',
      a6: 'Aucune limite. Une fois votre chanson livrée, elle vous appartient entièrement. Vous pouvez l\'écouter autant de fois que vous le souhaitez, la conserver à vie et la partager avec vos proches, sans aucune restriction.'
    },
    newsletter: {
      title: 'Rejoignez notre newsletter musicale',
      description: 'Renseignez votre e-mail pour être tenu au courant des nouveautés et bénéficier d\'offres exclusives.',
      placeholder: 'E-mail',
      button: 'S\'inscrire'
    },
    legal: {
      lastUpdated: 'Dernière mise à jour',
      updateDate: 'Janvier 2025',
      contact: {
        title: 'Nous Contacter'
      },
      terms: {
        title: 'Conditions Générales de Vente',
        section1: {
          title: '1. Acceptation des Conditions',
          content: 'En accédant et en utilisant les services de TRAKZSTUDIO, vous acceptez d\'être lié par ces Conditions Générales de Vente. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser nos services.'
        },
        section2: {
          title: '2. Description du Service',
          content: 'TRAKZSTUDIO fournit des services de création de chansons personnalisées. Notre service comprend :',
          item1: 'La création d\'une chanson personnalisée basée sur vos spécifications',
          item2: 'La production audio professionnelle et le mixage',
          item3: 'La livraison numérique par email et YouTube',
          item4: 'Un QR code pour un partage facile'
        },
        section3: {
          title: '3. Conditions de Paiement',
          content: 'Le paiement intégral est requis avant le début du travail sur votre chanson personnalisée. Nous acceptons les principales cartes de crédit via Stripe. Tous les prix sont en USD et incluent les taxes applicables.'
        },
        section4: {
          title: '4. Propriété Intellectuelle',
          content: 'Après paiement intégral, vous recevez une licence personnelle et non exclusive pour utiliser la chanson personnalisée. TRAKZSTUDIO conserve tous les droits de propriété intellectuelle sur la composition et les techniques de production.'
        },
        section5: {
          title: '5. Délais de Livraison',
          content: 'Le délai de livraison standard est de 5 à 7 jours ouvrables à partir de la confirmation de commande. Des options de livraison express sont disponibles moyennant des frais supplémentaires. Les délais de livraison sont des estimations et peuvent varier en fonction de la complexité de la commande.'
        },
        section6: {
          title: '6. Limitation de Responsabilité',
          content: 'TRAKZSTUDIO n\'est pas responsable des dommages indirects, accessoires ou consécutifs découlant de l\'utilisation de nos services. Notre responsabilité totale est limitée au montant payé pour le service.'
        }
      },
      privacy: {
        title: 'Politique de Confidentialité',
        section1: {
          title: '1. Informations que Nous Collectons',
          content: 'Nous collectons les informations personnelles que vous fournissez lors de la commande d\'une chanson personnalisée, y compris votre nom, adresse email, informations de paiement et les détails nécessaires à la création de votre chanson personnalisée.'
        },
        section2: {
          title: '2. Comment Nous Utilisons Vos Informations',
          content: 'Nous utilisons vos informations pour :',
          item1: 'Créer et livrer votre chanson personnalisée',
          item2: 'Traiter les paiements et envoyer les confirmations de commande',
          item3: 'Communiquer avec vous au sujet de votre commande',
          item4: 'Envoyer des emails promotionnels (avec votre consentement)'
        },
        section3: {
          title: '3. Sécurité des Données',
          content: 'Nous mettons en œuvre des mesures de sécurité standard de l\'industrie pour protéger vos informations personnelles. Le traitement des paiements est géré de manière sécurisée via Stripe, et nous ne stockons pas les informations de carte de crédit sur nos serveurs.'
        },
        section4: {
          title: '4. Services Tiers',
          content: 'Nous utilisons des services tiers incluant Stripe (traitement des paiements), Airtable (gestion des commandes) et YouTube (livraison de contenu). Ces services ont leurs propres politiques de confidentialité.'
        },
        section5: {
          title: '5. Vos Droits',
          content: 'Vous avez le droit d\'accéder, de corriger ou de supprimer vos informations personnelles. Vous pouvez également vous désabonner des communications marketing à tout moment en nous contactant.'
        },
        section6: {
          title: '6. Politique des Cookies',
          content: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site web. Vous pouvez contrôler les paramètres des cookies via les préférences de votre navigateur.'
        }
      },
      refund: {
        title: 'Politique de Retour et Remboursement',
        section1: {
          title: '1. Garantie de Satisfaction',
          content: 'Nous nous engageons à votre satisfaction. Si vous n\'êtes pas complètement satisfait de votre chanson personnalisée, veuillez nous contacter dans les 7 jours suivant la livraison.'
        },
        section2: {
          title: '2. Politique de Révision',
          content: 'Chaque commande comprend une série de révisions mineures sans frais supplémentaires. Les révisions doivent être demandées dans les 7 jours suivant la livraison initiale et sont limitées aux ajustements lyriques ou aux modifications mineures de production.'
        },
        section3: {
          title: '3. Éligibilité au Remboursement',
          content: 'Des remboursements peuvent être accordés dans les cas où nous ne sommes pas en mesure de livrer une chanson qui répond aux spécifications fournies dans votre commande. Les demandes de remboursement doivent être soumises dans les 14 jours suivant la date de livraison originale.'
        },
        section4: {
          title: '4. Articles Non Remboursables',
          content: 'En raison de la nature personnalisée de notre service, les remboursements ne sont pas disponibles une fois que vous avez approuvé la chanson finale. Les frais de livraison express et les frais de couplets supplémentaires sont également non remboursables.'
        },
        section5: {
          title: '5. Processus de Remboursement',
          content: 'Les remboursements approuvés seront traités dans les 5 à 10 jours ouvrables et crédités sur le mode de paiement original. Veuillez prévoir un délai supplémentaire pour que votre institution financière traite le remboursement.'
        },
        section6: {
          title: '6. Politique d\'Annulation',
          content: 'Les commandes peuvent être annulées dans les 24 heures suivant leur placement pour un remboursement complet. Après 24 heures, les annulations sont soumises à des frais de traitement de 30% si le travail a déjà commencé.'
        }
      }
    },
    trustpilot: {
      title: 'Ce qu\'ils pensent',
      titleHighlight: 'de nous',
      description: 'De vrais avis de vrais clients qui ont vécu la magie de la musique personnalisée',
      seeAllReviews: 'Voir tous les avis sur'
    },
    footer: {
      service: 'Service Client',
      menu: 'Menu',
      info: 'Informations',
      contact: 'Contact par mail du lundi au dimanche de 9h à 20h pour une réponse rapide !',
      terms: 'Conditions générales de vente',
      privacy: 'Politique de confidentialité',
      refund: 'Politique de retour & remboursement',
      legal: 'Mentions légales'
    }
  },
  es: {
    common: {
      views: 'vistas',
      subscribed: '¡Suscrito!',
      subscribedMessage: 'Gracias por suscribirte a nuestro boletín.',
      songExample: 'Para Mi Clara',
      totalPrice: 'Precio Total:',
      uploadPhoto: 'Subir Foto',
      uploaded: 'Subido',
      addPhotoButton: 'Agregar Otra Foto (Máx 10)',
      minPhotosWarning: 'Se requieren mínimo 3 fotos para CLIP IA',
      photoSlot: 'Foto',
      fileFormat: 'JPG, PNG o HEIC (Máx 10MB)',
      whatYouGet: '¡Lo que obtendrás: Un video de 30-60 segundos generado por IA combinando tus fotos con la canción, perfecto para compartir en redes sociales!',
      nameOrNamesPlaceholder: 'Nombre o nombres...',
      relationshipPlaceholder: 'Mi hijo, mi hija, mi mejor amigo...',
      occasionPlaceholder: 'Cumpleaños, Boda, Jubilación...',
      phrasePlaceholder: 'Tu frase simbólica...',
      verses2Free: '2 Versos (Gratis)',
      verses3: '3 Versos (+$3.90)',
      verses4: '4 Versos (+$6.90)'
    },
    nav: {
      home: 'Inicio',
      create: 'Crear tu canción',
      examples: 'Ejemplos',
      reviews: 'Opiniones',
      story: 'Nuestra historia',
      artists: 'Nuestros artistas',
      contact: 'Contacto'
    },
    hero: {
      badge: 'Tu canción al -50% hoy',
      reviewsBadge: '1582 Opiniones verificadas | +10,000 Canciones creadas',
      mainTitle: 'Regala la emoción en música',
      mainSubtitle: 'Una canción 100% original, creada a partir de tu historia',
      ctaButton: 'Crear una canción personalizada',
      priceText: 'Canción personalizada + código QR + YouTube:',
      price: '$35.00',
      originalPrice: '$70.00',
      discount: '¡-50% hoy!'
    },
    form: {
      title: 'Personaliza tu canción',
      quickBadge: '✨ Ordena en solo 4 minutos',
      subtitle: 'Responde las preguntas a continuación y crearemos una canción única, solo para ti.',
      required: 'Los campos marcados con * son obligatorios',
      whoFor: '¿Para quién es esta canción?',
      whoForHelp: '¡La canción puede dedicarse a varias personas! Ingresa sus nombres aquí.',
      relationship: 'Tu relación con esta persona',
      relationshipHelp: 'Especifica tu relación: mi hijo, mi hija, mi mamá, mi papá, mi esposo, mi esposa, mi mejor amigo...',
      occasion: '¿Es para una ocasión especial?',
      occasionHelp: '¡No necesitas una ocasión especial! Pero si es para un cumpleaños, jubilación, boda o nacimiento, especifícalo.',
      occasionNo: 'No',
      tellUs: 'Cuéntanos sobre esta persona',
      tellUsHelp: '¡Esta es la parte más importante! Cuéntanos quién es esta persona, qué amas de ella, un recuerdo fuerte...',
      tellUsPlaceholder: 'Un recuerdo, una cualidad, una broma, un momento especial... Cuantos más detalles compartas, más reflejará la canción realmente a esa persona.',
      styleTitle: 'Estilo y Ambiente',
      language: 'Idioma de la canción',
      languageHelp: 'La canción será cantada completamente en el idioma elegido.',
      selectLanguage: 'Selecciona un idioma',
      musicalStyle: 'Estilo musical',
      musicalStyleHelp: 'Elige el estilo que coincida con el gusto del destinatario.',
      selectStyle: 'Selecciona un estilo musical',
      era: 'Época / Años',
      selectEra: 'Selecciona una época',
      ambiance: 'Ambiente de la música',
      ambianceHelp: 'El ambiente define el tono emocional de la canción.',
      selectAmbiance: 'Selecciona un ambiente',
      voice: 'Voz del artista',
      voiceHelp: 'Estructura estándar: Verso 1 / Estribillo / Verso 2 / Estribillo. El Dúo combina voz masculina y femenina.',
      voiceMale: 'Hombre',
      voiceFemale: 'Mujer',
      voiceDuo: 'Dúo',
      options: 'Opciones',
      verses: 'Número de versos',
      versesHelp: 'Cada verso adicional enriquece la historia.',
      phrase: 'Agregar una frase simbólica',
      phraseHelp: 'La frase que escribas se integrará palabra por palabra en la canción.',
      streaming: '¿Agregar tu canción a plataformas de streaming?',
      streamingHelp: 'Tu canción estará disponible en Spotify, Apple Music, Deezer y más.',
      streamingNo: 'No, MP3 es suficiente',
      streamingYes: 'Sí',
      delivery: 'Tiempo de entrega',
      deliveryStandard: 'Estándar – 48h (Gratis)',
      deliveryExpress: 'Exprés – 24h',
      deliveryPriority: 'Prioritario – 12h',
      photo: 'Agregar una foto a la canción',
      photoHelp: 'Tu foto se integrará como portada en tu archivo MP3.',
      photoNo: 'No',
      voiceRecording: 'Agregar tu voz a la canción',
      voiceRecordingHelp: '¡Graba un mensaje personal, una dedicatoria o canta! Tu voz se integrará en la canción.',
      voiceRecordingNo: 'No',
      voiceRecordingYes: 'Sí, grabar mi voz',
      voiceOwner: '¿De quién es esta voz?',
      voiceOwnerPlaceholder: 'Nombre de la persona...',
      voiceRecordVoice1: 'Voz 1',
      voiceRecordVoice2: 'Voz 2',
      voiceRecordDuoNote: 'Como seleccionaste Dúo, puedes grabar 2 voces',
      voiceRecordStart: 'Iniciar grabación',
      voiceRecordStop: 'Detener grabación',
      voiceRecordPlay: 'Reproducir grabación',
      voiceRecordReRecord: 'Volver a grabar',
      voiceRecordingTime: 'Grabando',
      voiceRecordMaxDuration: 'Máx 60 segundos',
      voiceRecordInstructions: 'Haz clic en "Iniciar grabación" y habla tu mensaje. Puedes grabar hasta 60 segundos.',
      voiceRecordSuccess: '¡Voz grabada con éxito!',
      aiClip: 'Agregar CLIP de Video IA',
      aiClipHelp: '¡Crea un video personalizado con fotos de tus seres queridos y un escenario generado por IA. Perfecto para compartir en redes sociales!',
      aiClipNo: 'No, solo canción',
      aiClipYes: 'Sí, crear video IA',
      aiClipPhotos: 'Sube fotos para el video',
      aiClipPhotosHelp: 'Agrega de 3 a 10 fotos que se usarán en tu clip de video IA',
      aiClipPhotoName: '¿Quién está en esta foto?',
      aiClipPhotoNamePlaceholder: 'Nombre de la(s) persona(s)...',
      aiClipScenario: 'Describe el escenario del video',
      aiClipScenarioHelp: 'Dinos qué historia quieres que cuente el video (un viaje, momentos especiales, evolución en el tiempo...)',
      aiClipScenarioPlaceholder: 'Ejemplo: Un montaje de la infancia hasta hoy, nuestros mejores momentos de vacaciones, una línea de tiempo de amor...',
      email: 'Tu Dirección de Email',
      emailHelp: 'Enviaremos tu canción a esta dirección de email',
      emailPlaceholder: 'tu.email@ejemplo.com',
      deliveryInfo: 'Información de Entrega',
      deliveryStandard8h: 'Sin CLIP IA: 8 horas',
      deliveryWithClip16h: 'Con CLIP IA: 16 horas',
      proceedToPayment: 'Proceder al Pago',
      securePayment: '🔒 Pago 100% Seguro',
      orderNow: 'Ordena ahora para garantizar el procesamiento por nuestros artistas'
    },
    delivery: {
      title: 'Entrega rápida',
      description: 'Todos los pedidos se entregan en 48 horas. Si tienes prisa, puedes elegir una opción de entrega exprés para recibir tu canción en 12 o 24 horas.'
    },
    receive: {
      title: 'Lo que recibes',
      description: 'Tu canción te será enviada por correo electrónico en formato MP3, acompañada de la letra en PDF. Si eliges la opción de streaming, la canción también estará disponible en plataformas de música.'
    },
    guarantees: {
      title: 'Nuestras garantías',
      unlimited: 'Revisiones ilimitadas',
      unlimitedDesc: 'Ajustamos la canción tantas veces como sea necesario hasta que te guste.',
      satisfaction: 'Satisfacción garantizada o reembolso',
      satisfactionDesc: 'Si a pesar de las revisiones, ninguna versión te satisface, procedemos con un reembolso.',
      fast: 'Entrega rápida',
      fastDesc: 'Tu canción se entrega en 48 horas (o más rápido con opciones).',
      free: 'Uso libre',
      freeDesc: 'Puedes escuchar, compartir y regalar tu canción libremente.'
    },
    howItWorks: {
      title: '¿Cómo funciona?',
      step1: 'Completa el formulario',
      step1Desc: 'Cuéntanos sobre la persona y elige el estilo musical',
      step2: 'Nuestros artistas crean',
      step2Desc: 'Tu canción personalizada es compuesta y grabada',
      step3: 'Recibe y disfruta',
      step3Desc: 'Obtén tu canción por correo en 12-48h'
    },
    testimonials: {
      badge: 'Testimonios en Video',
      title: 'Sus Reacciones en Video',
      subtitle: 'Descubre la emoción auténtica de quienes han regalado o recibido una canción personalizada. Momentos inolvidables capturados en video.',
      playing: 'Reproduciendo...',
      listen: 'Escuchar la canción',
      ctaTitle: 'Tú también, crea un momento inolvidable',
      ctaSubtitle: 'Únete a miles de personas que han tocado corazones con una canción personalizada',
      ctaButton: 'Comenzar Tu Canción'
    },
    examples: {
      title: 'Escucha algunos ejemplos de canciones',
      subtitle: 'Estos ejemplos te permiten descubrir el estilo musical. Tu canción será creada especialmente para ti, con revisiones ilimitadas hasta la satisfacción.'
    },
    platforms: {
      title: 'Encuentra tu canción en'
    },
    artists: {
      title: 'Nuestros artistas multilingües',
      description: 'Artistas seleccionados por su sensibilidad musical y su capacidad de contar historias en canciones, en inglés, francés, español e italiano.',
      stat1: '100% Creación auténtica',
      stat2: '+10,000 Canciones únicas entregadas',
      stat3: '+5 años de excelencia musical'
    },
    why: {
      title: 'Por qué nuestros clientes nos aman',
      quality: 'Calidad profesional',
      qualityDesc: 'Cada canción se crea con los mismos requisitos que un verdadero título de estudio. Nuestros artistas usan herramientas profesionales para garantizar una calidad de sonido impecable.',
      personalization: 'Personalización completa',
      personalizationDesc: 'Letra, melodía, estilo, voz... Todo está diseñado para contar tu historia, con una canción que no se parece a ninguna otra.',
      speed: 'Velocidad de entrega',
      speedDesc: 'Gracias a un proceso optimizado, tu canción se crea rápidamente, sin comprometer la calidad. Ideal para un regalo de último momento.',
      unique: 'Regalo único y memorable',
      uniqueDesc: 'Ofrecer una canción personalizada es ofrecer una emoción. Un recuerdo que escuchamos, compartimos y atesoramos durante años.'
    },
    faq: {
      title: 'Preguntas frecuentes',
      q1: '¿Está protegida mi información personal?',
      a1: 'Absolutamente. El respeto de tu privacidad es una prioridad. Toda la información que compartes es estrictamente confidencial y se usa solo para crear tu canción personalizada.',
      q2: '¿Cuánto tiempo tarda en recibirse mi canción personalizada?',
      a2: 'Nuestro equipo de artistas se compromete a entregar tu canción en menos de 48 horas. Si eliges una opción de entrega prioritaria, tu canción puede estar lista en 12 o 24 horas.',
      q3: '¿Cómo recibiré mi canción?',
      a3: 'Tu canción te será enviada por correo electrónico, en formato MP3 de alta calidad, lista para ser escuchada, descargada y compartida. Si elegiste la opción de difusión, también estará disponible en las principales plataformas de streaming.',
      q4: '¿Puedo elegir el estilo musical de mi canción?',
      a4: 'Sí, por supuesto. Puedes elegir el estilo musical, el ambiente y el tipo de voz que desees. Ofrecemos una amplia variedad de géneros para que coincida mejor con los gustos de la persona a quien va dirigida la canción.',
      q5: '¿Qué pasa si no me gusta la canción?',
      a5: 'Tu satisfacción es nuestra prioridad. Si la primera versión de tu canción no cumple completamente con tus expectativas, te beneficias de revisiones incluidas para ajustar el resultado hasta que te convenga. Y si a pesar de las revisiones, ninguna versión te satisface, simplemente procedemos con un reembolso.',
      q6: '¿Hay un límite en el número de reproducciones de mi canción?',
      a6: 'Sin límite. Una vez entregada tu canción, te pertenece por completo. Puedes escucharla tantas veces como quieras, conservarla de por vida y compartirla con tus seres queridos, sin ninguna restricción.'
    },
    newsletter: {
      title: 'Únete a nuestro boletín musical',
      description: 'Ingresa tu correo electrónico para mantenerte informado de noticias y beneficiarte de ofertas exclusivas.',
      placeholder: 'Correo electrónico',
      button: 'Suscribirse'
    },
    trustpilot: {
      title: 'Amado por',
      titleHighlight: 'Miles',
      description: 'Reseñas reales de clientes reales que experimentaron la magia de la música personalizada',
      seeAllReviews: 'Ver todas las reseñas en'
    },
    footer: {
      service: 'Servicio al Cliente',
      menu: 'Menú',
      info: 'Información',
      contact: '¡Contacto por correo electrónico de lunes a domingo de 9 a.m. a 8 p.m. para una respuesta rápida!',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      refund: 'Política de Devolución y Reembolso',
      legal: 'Avisos Legales'
    }
  },
  it: {
    common: {
      views: 'visualizzazioni',
      subscribed: 'Iscritto!',
      subscribedMessage: 'Grazie per esserti iscritto alla nostra newsletter.',
      songExample: 'Per la Mia Clara',
      totalPrice: 'Prezzo Totale:',
      uploadPhoto: 'Carica Foto',
      uploaded: 'Caricato',
      addPhotoButton: 'Aggiungi Un\'Altra Foto (Max 10)',
      minPhotosWarning: 'Minimo 3 foto richieste per CLIP IA',
      photoSlot: 'Foto',
      fileFormat: 'JPG, PNG o HEIC (Max 10MB)',
      whatYouGet: 'Cosa otterrai: Un video di 30-60 secondi generato dall\'IA che combina le tue foto con la canzone, perfetto per condividere sui social media!',
      nameOrNamesPlaceholder: 'Nome o nomi...',
      relationshipPlaceholder: 'Mio figlio, mia figlia, il mio migliore amico...',
      occasionPlaceholder: 'Compleanno, Matrimonio, Pensionamento...',
      phrasePlaceholder: 'La tua frase simbolica...',
      verses2Free: '2 Strofe (Gratis)',
      verses3: '3 Strofe (+€3,90)',
      verses4: '4 Strofe (+€6,90)'
    },
    nav: {
      home: 'Home',
      create: 'Crea la tua canzone',
      examples: 'Esempi',
      reviews: 'Recensioni',
      story: 'La nostra storia',
      artists: 'I nostri artisti',
      contact: 'Contatto'
    },
    hero: {
      badge: 'La tua canzone al -50% oggi',
      reviewsBadge: '1582 Recensioni verificate | +10.000 Canzoni create',
      mainTitle: 'Regala l\'emozione in musica',
      mainSubtitle: 'Una canzone 100% originale, creata dalla tua storia',
      ctaButton: 'Crea una canzone personalizzata',
      priceText: 'Canzone personalizzata + codice QR + YouTube:',
      price: '€35,00',
      originalPrice: '€70,00',
      discount: '-50% oggi!'
    },
    form: {
      title: 'Personalizza la tua canzone',
      quickBadge: '✨ Ordina in soli 4 minuti',
      subtitle: 'Rispondi alle domande qui sotto e creeremo una canzone unica, solo per te.',
      required: 'I campi contrassegnati con * sono obbligatori',
      whoFor: 'Per chi è questa canzone?',
      whoForHelp: 'La canzone può essere dedicata a più persone! Inserisci qui i loro nomi.',
      relationship: 'La tua relazione con questa persona',
      relationshipHelp: 'Specifica la tua relazione: mio figlio, mia figlia, mia mamma, mio papà, mio marito, mia moglie, il mio migliore amico...',
      occasion: 'È per un\'occasione speciale?',
      occasionHelp: 'Non serve un\'occasione speciale! Ma se è per un compleanno, pensionamento, matrimonio o nascita, specificalo.',
      occasionNo: 'No',
      tellUs: 'Raccontaci di questa persona',
      tellUsHelp: 'Questa è la parte più importante! Dicci chi è questa persona, cosa ami di lei, un ricordo forte...',
      tellUsPlaceholder: 'Un ricordo, una qualità, una battuta, un momento speciale... Più dettagli condividi, più la canzone riflette veramente quella persona.',
      styleTitle: 'Stile e Atmosfera',
      language: 'Lingua della canzone',
      languageHelp: 'La canzone sarà cantata interamente nella lingua scelta.',
      selectLanguage: 'Seleziona una lingua',
      musicalStyle: 'Stile musicale',
      musicalStyleHelp: 'Scegli lo stile che corrisponde al gusto del destinatario.',
      selectStyle: 'Seleziona uno stile musicale',
      era: 'Epoca / Anni',
      selectEra: 'Seleziona un\'epoca',
      ambiance: 'Atmosfera della musica',
      ambianceHelp: 'L\'atmosfera definisce il tono emotivo della canzone.',
      selectAmbiance: 'Seleziona un\'atmosfera',
      voice: 'Voce dell\'artista',
      voiceHelp: 'Struttura standard: Strofa 1 / Ritornello / Strofa 2 / Ritornello. Il Duo combina voce maschile e femminile.',
      voiceMale: 'Uomo',
      voiceFemale: 'Donna',
      voiceDuo: 'Duo',
      options: 'Opzioni',
      verses: 'Numero di strofe',
      versesHelp: 'Ogni strofa aggiuntiva arricchisce la storia.',
      phrase: 'Aggiungi una frase simbolica',
      phraseHelp: 'La frase che scrivi sarà integrata parola per parola nella canzone.',
      streaming: 'Aggiungere la tua canzone alle piattaforme di streaming?',
      streamingHelp: 'La tua canzone sarà disponibile su Spotify, Apple Music, Deezer e altro.',
      streamingNo: 'No, MP3 è sufficiente',
      streamingYes: 'Sì',
      delivery: 'Tempo di consegna',
      deliveryStandard: 'Standard – 48h (Gratis)',
      deliveryExpress: 'Express – 24h',
      deliveryPriority: 'Prioritario – 12h',
      photo: 'Aggiungi una foto alla canzone',
      photoHelp: 'La tua foto sarà integrata come copertina sul tuo file MP3.',
      photoNo: 'No',
      voiceRecording: 'Aggiungi la tua voce alla canzone',
      voiceRecordingHelp: 'Registra un messaggio personale, una dedica o canta! La tua voce sarà integrata nella canzone.',
      voiceRecordingNo: 'No',
      voiceRecordingYes: 'Sì, registra la mia voce',
      voiceOwner: 'Di chi è questa voce?',
      voiceOwnerPlaceholder: 'Nome della persona...',
      voiceRecordVoice1: 'Voce 1',
      voiceRecordVoice2: 'Voce 2',
      voiceRecordDuoNote: 'Poiché hai selezionato Duo, puoi registrare 2 voci',
      voiceRecordStart: 'Inizia registrazione',
      voiceRecordStop: 'Ferma registrazione',
      voiceRecordPlay: 'Riproduci registrazione',
      voiceRecordReRecord: 'Registra di nuovo',
      voiceRecordingTime: 'Registrazione',
      voiceRecordMaxDuration: 'Max 60 secondi',
      voiceRecordInstructions: 'Fai clic su "Inizia registrazione" e parla il tuo messaggio. Puoi registrare fino a 60 secondi.',
      voiceRecordSuccess: 'Voce registrata con successo!',
      aiClip: 'Aggiungi CLIP Video IA',
      aiClipHelp: 'Crea un video personalizzato con le foto dei tuoi cari e uno scenario generato dall\'IA. Perfetto per condividere sui social media!',
      aiClipNo: 'No, solo canzone',
      aiClipYes: 'Sì, crea video IA',
      aiClipPhotos: 'Carica foto per il video',
      aiClipPhotosHelp: 'Aggiungi da 3 a 10 foto che saranno utilizzate nel tuo video clip IA',
      aiClipPhotoName: 'Chi è in questa foto?',
      aiClipPhotoNamePlaceholder: 'Nome della/e persona/e...',
      aiClipScenario: 'Descrivi lo scenario del video',
      aiClipScenarioHelp: 'Dicci quale storia vuoi che racconti il video (un viaggio, momenti speciali, evoluzione nel tempo...)',
      aiClipScenarioPlaceholder: 'Esempio: Un montaggio dall\'infanzia ad oggi, i nostri migliori momenti di vacanza, una cronologia d\'amore...',
      email: 'Il Tuo Indirizzo Email',
      emailHelp: 'Invieremo la tua canzone a questo indirizzo email',
      emailPlaceholder: 'tua.email@esempio.com',
      deliveryInfo: 'Informazioni sulla Consegna',
      deliveryStandard8h: 'Senza CLIP IA: 8 ore',
      deliveryWithClip16h: 'Con CLIP IA: 16 ore',
      proceedToPayment: 'Procedi al Pagamento',
      securePayment: '🔒 Pagamento 100% Sicuro',
      orderNow: 'Ordina ora per garantire l\'elaborazione da parte dei nostri artisti'
    },
    delivery: {
      title: 'Consegna rapida',
      description: 'Tutti gli ordini vengono consegnati entro 48 ore. Se hai fretta, puoi scegliere un\'opzione di consegna express per ricevere la tua canzone in 12 o 24 ore.'
    },
    receive: {
      title: 'Cosa ricevi',
      description: 'La tua canzone ti sarà inviata via email in formato MP3, accompagnata dai testi in PDF. Se scegli l\'opzione streaming, la canzone sarà disponibile anche sulle piattaforme musicali.'
    },
    guarantees: {
      title: 'Le nostre garanzie',
      unlimited: 'Revisioni illimitate',
      unlimitedDesc: 'Regoliamo la canzone tutte le volte necessarie finché non ti piace.',
      satisfaction: 'Soddisfazione garantita o rimborso',
      satisfactionDesc: 'Se nonostante le revisioni, nessuna versione ti soddisfa, procediamo con un rimborso.',
      fast: 'Consegna rapida',
      fastDesc: 'La tua canzone viene consegnata entro 48 ore (o più velocemente con le opzioni).',
      free: 'Uso libero',
      freeDesc: 'Puoi ascoltare, condividere e regalare la tua canzone liberamente.'
    },
    howItWorks: {
      title: 'Come funziona?',
      step1: 'Compila il modulo',
      step1Desc: 'Raccontaci della persona e scegli lo stile musicale',
      step2: 'I nostri artisti creano',
      step2Desc: 'La tua canzone personalizzata viene composta e registrata',
      step3: 'Ricevi e goditi',
      step3Desc: 'Ricevi la tua canzone via email in 12-48h'
    },
    testimonials: {
      badge: 'Testimonianze Video',
      title: 'Le Loro Reazioni in Video',
      subtitle: 'Scopri l\'emozione autentica di coloro che hanno regalato o ricevuto una canzone personalizzata. Momenti indimenticabili catturati in video.',
      playing: 'In riproduzione...',
      listen: 'Ascolta la canzone',
      ctaTitle: 'Anche tu, crea un momento indimenticabile',
      ctaSubtitle: 'Unisciti a migliaia di persone che hanno toccato i cuori con una canzone personalizzata',
      ctaButton: 'Inizia La Tua Canzone'
    },
    examples: {
      title: 'Ascolta alcuni esempi di canzoni',
      subtitle: 'Questi esempi ti permettono di scoprire lo stile musicale. La tua canzone sarà poi creata appositamente per te, con revisioni illimitate fino alla soddisfazione.'
    },
    platforms: {
      title: 'Trova la tua canzone su'
    },
    artists: {
      title: 'I nostri artisti multilingue',
      description: 'Artisti selezionati per la loro sensibilità musicale e la loro capacità di raccontare storie in canzoni, in inglese, francese, spagnolo e italiano.',
      stat1: '100% Creazione autentica',
      stat2: '+10.000 Canzoni uniche consegnate',
      stat3: '+5 anni di eccellenza musicale'
    },
    why: {
      title: 'Perché i nostri clienti ci adorano',
      quality: 'Qualità professionale',
      qualityDesc: 'Ogni canzone è creata con gli stessi requisiti di un vero titolo da studio. I nostri artisti usano strumenti professionali per garantire una qualità sonora impeccabile.',
      personalization: 'Personalizzazione completa',
      personalizationDesc: 'Testo, melodia, stile, voce... Tutto è pensato su misura per raccontare la tua storia, con una canzone che non assomiglia a nessun\'altra.',
      speed: 'Velocità di consegna',
      speedDesc: 'Grazie a un processo ottimizzato, la tua canzone viene creata rapidamente, senza compromessi sulla qualità. Ideale per un regalo dell\'ultimo minuto.',
      unique: 'Regalo unico e memorabile',
      uniqueDesc: 'Regalare una canzone personalizzata significa regalare un\'emozione. Un ricordo che ascoltiamo, condividiamo e amiamo per anni.'
    },
    faq: {
      title: 'Domande frequenti',
      q1: 'Le mie informazioni personali sono protette?',
      a1: 'Assolutamente. Il rispetto della tua privacy è una priorità. Tutte le informazioni che condividi sono strettamente confidenziali e utilizzate solo per creare la tua canzone personalizzata.',
      q2: 'Quanto tempo ci vuole per ricevere la mia canzone personalizzata?',
      a2: 'Il nostro team di artisti si impegna a consegnare la tua canzone in meno di 48 ore. Se scegli un\'opzione di consegna prioritaria, la tua canzone può essere pronta in 12 o 24 ore.',
      q3: 'Come riceverò la mia canzone?',
      a3: 'La tua canzone ti sarà inviata via email, in formato MP3 di alta qualità, pronta per essere ascoltata, scaricata e condivisa. Se hai scelto l\'opzione di diffusione, sarà disponibile anche sulle principali piattaforme di streaming.',
      q4: 'Posso scegliere lo stile musicale della mia canzone?',
      a4: 'Sì, certo. Puoi scegliere lo stile musicale, l\'atmosfera e il tipo di voce che desideri. Offriamo un\'ampia varietà di generi per corrispondere al meglio ai gusti della persona a cui è destinata la canzone.',
      q5: 'Cosa succede se non mi piace la canzone?',
      a5: 'La tua soddisfazione è la nostra priorità. Se la prima versione della tua canzone non corrisponde completamente alle tue aspettative, benefici di revisioni incluse per regolare il risultato finché non ti conviene. E se nonostante le revisioni, nessuna versione ti soddisfa, procediamo semplicemente con un rimborso.',
      q6: 'C\'è un limite al numero di ascolti della mia canzone?',
      a6: 'Nessun limite. Una volta consegnata la tua canzone, ti appartiene interamente. Puoi ascoltarla tutte le volte che vuoi, conservarla a vita e condividerla con i tuoi cari, senza alcuna restrizione.'
    },
    newsletter: {
      title: 'Unisciti alla nostra newsletter musicale',
      description: 'Inserisci la tua email per rimanere informato sulle novità e beneficiare di offerte esclusive.',
      placeholder: 'Email',
      button: 'Iscriviti'
    },
    trustpilot: {
      title: 'Amato da',
      titleHighlight: 'Migliaia',
      description: 'Recensioni reali di clienti reali che hanno vissuto la magia della musica personalizzata',
      seeAllReviews: 'Vedi tutte le recensioni su'
    },
    footer: {
      service: 'Servizio clienti',
      menu: 'Menu',
      info: 'Informazioni',
      contact: 'Contatto via email dal lunedì alla domenica dalle 9:00 alle 20:00 per una risposta rapida!',
      terms: 'Termini e condizioni',
      privacy: 'Informativa sulla privacy',
      refund: 'Politica di reso e rimborso',
      legal: 'Note legali'
    }
  },
  de: {
    common: {
      views: 'Aufrufe',
      subscribed: 'Abonniert!',
      subscribedMessage: 'Vielen Dank für Ihr Newsletter-Abonnement.',
      songExample: 'Für meine Clara',
      totalPrice: 'Gesamtpreis:',
      uploadPhoto: 'Foto hochladen',
      uploaded: 'Hochgeladen',
      addPhotoButton: 'Weiteres Foto hinzufügen (Max 10)',
      minPhotosWarning: 'Mindestens 3 Fotos für AI CLIP erforderlich',
      photoSlot: 'Foto',
      fileFormat: 'JPG, PNG oder HEIC (Max 10MB)',
      whatYouGet: 'Was Sie erhalten: Ein 30-60 Sekunden KI-generiertes Video, das Ihre Fotos mit dem Song kombiniert, perfekt zum Teilen in sozialen Medien!',
      nameOrNamesPlaceholder: 'Name oder Namen...',
      relationshipPlaceholder: 'Mein Sohn, meine Tochter, mein bester Freund...',
      occasionPlaceholder: 'Geburtstag, Hochzeit, Ruhestand...',
      phrasePlaceholder: 'Ihr symbolischer Satz...',
      verses2Free: '2 Strophen (Kostenlos)',
      verses3: '3 Strophen (+3,90€)',
      verses4: '4 Strophen (+6,90€)'
    },
    nav: {
      home: 'Startseite',
      create: 'Song erstellen',
      examples: 'Beispiele',
      reviews: 'Bewertungen',
      story: 'Unsere Geschichte',
      artists: 'Unsere Künstler',
      contact: 'Kontakt'
    },
    hero: {
      badge: 'Ihr Song heute -50%',
      reviewsBadge: '1582 Verifizierte Bewertungen | +10.000 Erstellte Songs',
      mainTitle: 'Schenken Sie Emotionen in Musik',
      mainSubtitle: 'Ein 100% originaler Song, erstellt aus Ihrer Geschichte',
      ctaButton: 'Personalisierten Song erstellen',
      priceText: 'Personalisierter Song + QR-Code + YouTube:',
      price: '39,90€',
      originalPrice: '70,00€',
      discount: '-50% heute!'
    },
    form: {
      title: 'Personalisieren Sie Ihren Song',
      quickBadge: '✨ Bestellen in nur 4 Minuten',
      subtitle: 'Beantworten Sie die folgenden Fragen und wir erstellen einen einzigartigen Song für Sie.',
      required: 'Pflichtfelder sind mit * markiert',
      whoFor: 'Für wen ist dieser Song?',
      whoForHelp: 'Der Song kann mehreren Personen gewidmet werden! Geben Sie hier ihre Namen ein.',
      relationship: 'Ihre Beziehung zu dieser Person',
      relationshipHelp: 'Geben Sie Ihre Beziehung an: mein Sohn, meine Tochter, meine Mutter, mein Vater, mein Mann, meine Frau, mein bester Freund...',
      occasion: 'Gibt es einen besonderen Anlass?',
      occasionHelp: 'Kein besonderer Anlass nötig! Aber wenn es für einen Geburtstag, Ruhestand, Hochzeit oder Geburt ist, geben Sie es an.',
      occasionNo: 'Nein',
      tellUs: 'Erzählen Sie uns von dieser Person',
      tellUsHelp: 'Das ist der wichtigste Teil! Erzählen Sie uns, wer diese Person ist, was Sie an ihr lieben, eine starke Erinnerung, ihre Leidenschaften...',
      tellUsPlaceholder: 'Eine Erinnerung, eine Eigenschaft, ein Witz, ein besonderer Moment... Je mehr Details Sie teilen, desto mehr wird der Song diese Person widerspiegeln.',
      styleTitle: 'Stil & Atmosphäre',
      language: 'Song-Sprache',
      languageHelp: 'Der Song wird vollständig in der gewählten Sprache gesungen.',
      selectLanguage: 'Sprache wählen',
      musicalStyle: 'Musikstil',
      musicalStyleHelp: 'Wählen Sie den Stil, der dem Geschmack des Empfängers entspricht.',
      selectStyle: 'Musikstil wählen',
      era: 'Ära / Jahre',
      selectEra: 'Ära wählen',
      ambiance: 'Musik-Atmosphäre',
      ambianceHelp: 'Die Atmosphäre definiert den emotionalen Ton des Songs.',
      selectAmbiance: 'Atmosphäre wählen',
      voice: 'Künstlerstimme',
      voiceHelp: 'Standardstruktur: Strophe 1 / Refrain / Strophe 2 / Refrain. Duett kombiniert männliche und weibliche Stimme.',
      voiceMale: 'Männlich',
      voiceFemale: 'Weiblich',
      voiceDuo: 'Duett',
      options: 'Optionen',
      verses: 'Anzahl der Strophen',
      versesHelp: 'Jede zusätzliche Strophe bereichert die Geschichte.',
      phrase: 'Symbolischen Satz hinzufügen',
      phraseHelp: 'Der Satz, den Sie schreiben, wird wörtlich in den Song integriert.',
      streaming: 'Song auf Streaming-Plattformen hinzufügen?',
      streamingHelp: 'Ihr Song wird auf Spotify, Apple Music, Deezer und mehr verfügbar sein.',
      streamingNo: 'Nein, MP3 reicht',
      streamingYes: 'Ja',
      delivery: 'Lieferzeit',
      deliveryStandard: 'Standard – 48h (Kostenlos)',
      deliveryExpress: 'Express – 24h',
      deliveryPriority: 'Priorität – 12h',
      photo: 'Foto zum Song hinzufügen',
      photoHelp: 'Ihr Foto wird als Cover in Ihre MP3-Datei integriert.',
      photoNo: 'Nein',
      voiceRecording: 'Ihre Stimme zum Song hinzufügen',
      voiceRecordingHelp: 'Nehmen Sie eine persönliche Nachricht, Widmung oder singen Sie mit! Ihre Stimme wird in den Song integriert.',
      voiceRecordingNo: 'Nein',
      voiceRecordingYes: 'Ja, meine Stimme aufnehmen',
      voiceOwner: 'Wessen Stimme ist das?',
      voiceOwnerPlaceholder: 'Name der Person...',
      voiceRecordVoice1: 'Stimme 1',
      voiceRecordVoice2: 'Stimme 2',
      voiceRecordDuoNote: 'Da Sie Duett gewählt haben, können Sie 2 Stimmen aufnehmen',
      voiceRecordStart: 'Aufnahme starten',
      voiceRecordStop: 'Aufnahme stoppen',
      voiceRecordDelete: 'Aufnahme löschen',
      voiceRecordPlay: 'Abspielen',
      voiceRecordPause: 'Pause',
      voiceRecordSaved: 'Gespeichert',
      aiClip: 'KI-Video-Clip hinzufügen',
      aiClipHelp: 'Erstellen Sie ein 30-60 Sekunden Video mit Ihren Fotos und dem Song, perfekt für soziale Medien!',
      aiClipNo: 'Nein',
      aiClipYes: 'Ja, Video erstellen',
      aiClipPhotosTitle: 'Fotos für KI-Clip hochladen',
      aiClipPhotosHelp: 'Laden Sie 3 bis 10 Fotos hoch. Die KI erstellt ein Video mit diesen Bildern.',
      aiClipContextLabel: 'Kontext für dieses Foto',
      aiClipContextPlaceholder: 'Beschreiben Sie den Kontext: Am Strand, im Garten, bei einem Fest...',
      aiClipScenarioLabel: 'Video-Szenario',
      aiClipScenarioHelp: 'Beschreiben Sie die gewünschte Atmosphäre für Ihr Video.',
      aiClipScenarioPlaceholder: 'Glückliche Momente, Familienerinnerungen, emotionale Reise...',
      email: 'Ihre E-Mail',
      emailHelp: 'Wir senden Ihren Song an diese Adresse.',
      emailPlaceholder: 'ihre-email@beispiel.de',
      submit: 'Meine personalisierte Song erstellen',
      submitting: 'Wird erstellt...',
      continue: 'Weiter',
      back: 'Zurück',
      step: 'Schritt'
    },
    guarantees: {
      title: 'Unsere Versprechen an Sie',
      satisfaction: '100% Zufriedenheit oder Geld zurück',
      satisfactionDesc: 'Wir garantieren Ihre volle Zufriedenheit oder erstatten Ihnen Ihr Geld zurück, ohne Fragen zu stellen.',
      fast: 'Schnelle Lieferung',
      fastDesc: 'Ihr Song wird innerhalb von 48 Stunden erstellt und geliefert.',
      original: '100% Original',
      originalDesc: 'Jeder Song ist einzigartig, speziell für Sie komponiert.',
      secure: 'Sichere Zahlung',
      secureDesc: 'Ihre Daten sind mit SSL-Verschlüsselung geschützt.'
    },
    testimonials: {
      title: 'Ihre Reaktionen auf Video'
    },
    howItWorks: {
      title: 'Wie es funktioniert',
      step1: 'Erzählen Sie Ihre Geschichte',
      step1Desc: 'Füllen Sie ein einfaches Formular aus, um uns über die Person zu erzählen.',
      step2: 'Wir erstellen Ihren Song',
      step2Desc: 'Unsere Künstler komponieren ein einzigartiges Lied aus Ihrer Geschichte.',
      step3: 'Erhalten Sie Ihren Song',
      step3Desc: 'Ihr Song wird innerhalb von 48 Stunden per E-Mail geliefert.'
    },
    artists: {
      title: 'Unsere mehrsprachigen Künstler',
      description: 'Künstler ausgewählt für ihre musikalische Sensibilität und ihre Fähigkeit, Geschichten in Songs zu erzählen, in Englisch, Französisch, Spanisch, Deutsch und Italienisch.',
      stat1: '100% Authentische Kreation',
      stat2: '+10.000 Einzigartige Songs geliefert',
      stat3: '+5 Jahre Musikalische Exzellenz'
    },
    why: {
      title: 'Warum unsere Kunden uns lieben',
      quality: 'Professionelle Qualität',
      qualityDesc: 'Jeder Song wird mit den gleichen Anforderungen wie ein echter Studio-Titel erstellt. Unsere Künstler verwenden professionelle Werkzeuge, um eine makellose Klangqualität zu gewährleisten.',
      personalization: 'Vollständige Personalisierung',
      personalizationDesc: 'Text, Melodie, Stil, Stimme... Alles ist maßgeschneidert, um Ihre Geschichte zu erzählen, mit einem Song, der keinem anderen ähnelt.',
      speed: 'Liefergeschwindigkeit',
      speedDesc: 'Dank eines optimierten Prozesses wird Ihr Song schnell erstellt, ohne Kompromisse bei der Qualität. Ideal für ein Last-Minute-Geschenk.',
      unique: 'Einzigartiges und unvergessliches Geschenk',
      uniqueDesc: 'Einen personalisierten Song zu schenken bedeutet, eine Emotion zu schenken. Eine Erinnerung, die wir hören, teilen und jahrelang lieben.'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      q1: 'Sind meine persönlichen Daten geschützt?',
      a1: 'Absolut. Der Schutz Ihrer Privatsphäre ist eine Priorität. Alle Informationen, die Sie teilen, sind streng vertraulich und werden nur zur Erstellung Ihres personalisierten Songs verwendet.',
      q2: 'Wie lange dauert es, bis ich meinen personalisierten Song erhalte?',
      a2: 'Unser Künstlerteam verpflichtet sich, Ihren Song in weniger als 48 Stunden zu liefern. Wenn Sie eine prioritäre Lieferoption wählen, kann Ihr Song in 12 oder 24 Stunden fertig sein.',
      q3: 'Wie erhalte ich meinen Song?',
      a3: 'Ihr Song wird Ihnen per E-Mail gesendet, im hochwertigen MP3-Format, bereit zum Anhören, Herunterladen und Teilen. Wenn Sie die Streaming-Option gewählt haben, wird er auch auf den wichtigsten Streaming-Plattformen verfügbar sein.',
      q4: 'Kann ich den Musikstil meines Songs wählen?',
      a4: 'Ja, natürlich. Sie können den Musikstil, die Atmosphäre und die Art der Stimme wählen, die Sie wünschen. Wir bieten eine breite Palette von Genres, um dem Geschmack der Person, für die der Song bestimmt ist, am besten zu entsprechen.',
      q5: 'Was passiert, wenn mir der Song nicht gefällt?',
      a5: 'Ihre Zufriedenheit ist unsere Priorität. Wenn die erste Version Ihres Songs nicht vollständig Ihren Erwartungen entspricht, profitieren Sie von enthaltenen Überarbeitungen, um das Ergebnis anzupassen, bis es Ihnen passt. Und wenn trotz der Überarbeitungen keine Version Sie zufriedenstellt, führen wir einfach eine Rückerstattung durch.',
      q6: 'Gibt es ein Limit für die Anzahl der Wiedergaben meines Songs?',
      a6: 'Kein Limit. Sobald Ihr Song geliefert wurde, gehört er vollständig Ihnen. Sie können ihn so oft anhören, wie Sie möchten, ihn ein Leben lang behalten und ihn mit Ihren Lieben teilen, ohne jegliche Einschränkung.'
    },
    newsletter: {
      title: 'Treten Sie unserem Musik-Newsletter bei',
      description: 'Geben Sie Ihre E-Mail ein, um über Neuigkeiten informiert zu bleiben und von exklusiven Angeboten zu profitieren.',
      placeholder: 'E-Mail',
      button: 'Abonnieren'
    },
    trustpilot: {
      title: 'Geliebt von',
      titleHighlight: 'Tausenden',
      description: 'Echte Bewertungen von echten Kunden, die die Magie personalisierter Musik erlebt haben',
      seeAllReviews: 'Alle Bewertungen ansehen auf'
    },
    footer: {
      service: 'Kundenservice',
      menu: 'Menü',
      info: 'Informationen',
      contact: 'Kontakt per E-Mail von Montag bis Sonntag von 9:00 bis 20:00 Uhr für eine schnelle Antwort!',
      terms: 'Allgemeine Geschäftsbedingungen',
      privacy: 'Datenschutzerklärung',
      refund: 'Rückgabe- und Erstattungsrichtlinie',
      legal: 'Impressum'
    }
  },
  pt: {
    common: {
      views: 'visualizações',
      subscribed: 'Inscrito!',
      subscribedMessage: 'Obrigado por se inscrever na nossa newsletter.',
      songExample: 'Para Minha Clara',
      totalPrice: 'Preço Total:',
      uploadPhoto: 'Carregar Foto',
      uploaded: 'Carregado',
      addPhotoButton: 'Adicionar Outra Foto (Máx 10)',
      minPhotosWarning: 'Mínimo de 3 fotos necessárias para IA CLIP',
      photoSlot: 'Foto',
      fileFormat: 'JPG, PNG ou HEIC (Máx 10MB)',
      whatYouGet: 'O que você receberá: Um vídeo de 30-60 segundos gerado por IA combinando suas fotos com a música, perfeito para compartilhar nas redes sociais!',
      nameOrNamesPlaceholder: 'Nome ou nomes...',
      relationshipPlaceholder: 'Meu filho, minha filha, meu melhor amigo...',
      occasionPlaceholder: 'Aniversário, Casamento, Aposentadoria...',
      phrasePlaceholder: 'Sua frase simbólica...',
      verses2Free: '2 Versos (Grátis)',
      verses3: '3 Versos (+R$ 20)',
      verses4: '4 Versos (+R$ 35)'
    },
    nav: {
      home: 'Início',
      create: 'Criar Sua Música',
      examples: 'Exemplos',
      reviews: 'Avaliações',
      story: 'Nossa História',
      artists: 'Nossos Artistas',
      contact: 'Contato'
    },
    hero: {
      badge: 'Sua música com -50% hoje',
      reviewsBadge: '1582 Avaliações Verificadas | +10.000 Músicas Criadas',
      mainTitle: 'Dê o presente da emoção em música',
      mainSubtitle: 'Uma música 100% original, criada a partir da sua história',
      ctaButton: 'Criar uma música personalizada',
      priceText: 'Música personalizada + QR code + YouTube:',
      price: 'R$ 199,90',
      originalPrice: 'R$ 350,00',
      discount: '-50% hoje!'
    },
    form: {
      title: 'Personalize Sua Música',
      quickBadge: '✨ Peça em apenas 4 minutos',
      subtitle: 'Responda às perguntas abaixo e criaremos uma música única, só para você.',
      required: 'Campos obrigatórios marcados com *',
      whoFor: 'Para quem é esta música?',
      whoForHelp: 'A música pode ser dedicada a várias pessoas! Digite seus nomes aqui.',
      relationship: 'Seu relacionamento com essa pessoa',
      relationshipHelp: 'Especifique seu relacionamento: meu filho, minha filha, minha mãe, meu pai, meu marido, minha esposa, meu melhor amigo...',
      occasion: 'É para uma ocasião especial?',
      occasionHelp: 'Não precisa de uma ocasião especial! Mas se for para um aniversário, aposentadoria, casamento ou nascimento, especifique.',
      occasionNo: 'Não',
      tellUs: 'Conte-nos sobre essa pessoa',
      tellUsHelp: 'Esta é a parte mais importante! Conte-nos quem é essa pessoa, o que você ama nela, uma memória forte, suas paixões...',
      tellUsPlaceholder: 'Uma memória, uma qualidade, uma piada, um momento especial... Quanto mais detalhes você compartilhar, mais a música refletirá essa pessoa.',
      styleTitle: 'Estilo & Ambiente',
      language: 'Idioma da Música',
      languageHelp: 'A música será totalmente cantada no idioma escolhido.',
      selectLanguage: 'Selecione um idioma',
      musicalStyle: 'Estilo Musical',
      musicalStyleHelp: 'Escolha o estilo que corresponde ao gosto do destinatário.',
      selectStyle: 'Selecione um estilo musical',
      era: 'Era / Anos',
      selectEra: 'Selecione uma era',
      ambiance: 'Ambiente Musical',
      ambianceHelp: 'O ambiente define o tom emocional da música.',
      selectAmbiance: 'Selecione um ambiente',
      voice: 'Voz do Artista',
      voiceHelp: 'Estrutura padrão: Verso 1 / Refrão / Verso 2 / Refrão. Dueto combina voz masculina e feminina.',
      voiceMale: 'Masculino',
      voiceFemale: 'Feminino',
      voiceDuo: 'Dueto',
      options: 'Opções',
      verses: 'Número de Versos',
      versesHelp: 'Cada verso adicional enriquece a história.',
      phrase: 'Adicionar uma frase simbólica',
      phraseHelp: 'A frase que você escrever será integrada palavra por palavra na música.',
      streaming: 'Adicionar sua música às plataformas de streaming?',
      streamingHelp: 'Sua música estará disponível no Spotify, Apple Music, Deezer e muito mais.',
      streamingNo: 'Não, MP3 é suficiente',
      streamingYes: 'Sim',
      delivery: 'Prazo de Entrega',
      deliveryStandard: 'Padrão – 48h (Grátis)',
      deliveryExpress: 'Expresso – 24h',
      deliveryPriority: 'Prioritário – 12h',
      photo: 'Adicionar uma foto à música',
      photoHelp: 'Sua foto será integrada como capa no seu arquivo MP3.',
      photoNo: 'Não',
      voiceRecording: 'Adicionar sua voz à música',
      voiceRecordingHelp: 'Grave uma mensagem pessoal, dedicatória ou cante junto! Sua voz será integrada na música.',
      voiceRecordingNo: 'Não',
      voiceRecordingYes: 'Sim, gravar minha voz',
      voiceOwner: 'De quem é esta voz?',
      voiceOwnerPlaceholder: 'Nome da pessoa...',
      voiceRecordVoice1: 'Voz 1',
      voiceRecordVoice2: 'Voz 2',
      voiceRecordDuoNote: 'Como você selecionou Dueto, você pode gravar 2 vozes',
      voiceRecordStart: 'Iniciar Gravação',
      voiceRecordStop: 'Parar Gravação',
      voiceRecordDelete: 'Excluir Gravação',
      voiceRecordPlay: 'Reproduzir',
      voiceRecordPause: 'Pausar',
      voiceRecordSaved: 'Salvo',
      aiClip: 'Adicionar clipe de vídeo IA',
      aiClipHelp: 'Crie um vídeo de 30-60 segundos com suas fotos e a música, perfeito para redes sociais!',
      aiClipNo: 'Não',
      aiClipYes: 'Sim, criar vídeo',
      aiClipPhotosTitle: 'Carregar fotos para IA Clip',
      aiClipPhotosHelp: 'Carregue de 3 a 10 fotos. A IA criará um vídeo com essas imagens.',
      aiClipContextLabel: 'Contexto para esta foto',
      aiClipContextPlaceholder: 'Descreva o contexto: Na praia, no jardim, numa festa...',
      aiClipScenarioLabel: 'Cenário do vídeo',
      aiClipScenarioHelp: 'Descreva o ambiente desejado para seu vídeo.',
      aiClipScenarioPlaceholder: 'Momentos felizes, memórias familiares, jornada emocional...',
      email: 'Seu E-mail',
      emailHelp: 'Enviaremos sua música para este endereço.',
      emailPlaceholder: 'seu-email@exemplo.com.br',
      submit: 'Criar minha música personalizada',
      submitting: 'Criando...',
      continue: 'Continuar',
      back: 'Voltar',
      step: 'Passo'
    },
    guarantees: {
      title: 'Nossas Promessas para Você',
      satisfaction: '100% Satisfação ou seu dinheiro de volta',
      satisfactionDesc: 'Garantimos sua total satisfação ou devolvemos seu dinheiro, sem perguntas.',
      fast: 'Entrega Rápida',
      fastDesc: 'Sua música será criada e entregue em até 48 horas.',
      original: '100% Original',
      originalDesc: 'Cada música é única, especialmente composta para você.',
      secure: 'Pagamento Seguro',
      secureDesc: 'Seus dados estão protegidos com criptografia SSL.'
    },
    testimonials: {
      title: 'Suas Reações em Vídeo'
    },
    howItWorks: {
      title: 'Como Funciona',
      step1: 'Conte Sua História',
      step1Desc: 'Preencha um formulário simples para nos contar sobre a pessoa.',
      step2: 'Criamos Sua Música',
      step2Desc: 'Nossos artistas compõem uma música única a partir da sua história.',
      step3: 'Receba Sua Música',
      step3Desc: 'Sua música será entregue por e-mail em até 48 horas.'
    },
    artists: {
      title: 'Nossos Artistas Multilíngues',
      description: 'Artistas selecionados por sua sensibilidade musical e capacidade de contar histórias em músicas, em inglês, francês, espanhol, português e italiano.',
      stat1: '100% Criação Autêntica',
      stat2: '+10.000 Músicas Únicas Entregues',
      stat3: '+5 Anos de Excelência Musical'
    },
    why: {
      title: 'Por Que Nossos Clientes Nos Amam',
      quality: 'Qualidade Profissional',
      qualityDesc: 'Cada música é criada com os mesmos requisitos de um verdadeiro título de estúdio. Nossos artistas usam ferramentas profissionais para garantir uma qualidade sonora impecável.',
      personalization: 'Personalização Completa',
      personalizationDesc: 'Letra, melodia, estilo, voz... Tudo é feito sob medida para contar sua história, com uma música que não se parece com nenhuma outra.',
      speed: 'Velocidade de Entrega',
      speedDesc: 'Graças a um processo otimizado, sua música é criada rapidamente, sem comprometer a qualidade. Ideal para um presente de última hora.',
      unique: 'Presente Único e Memorável',
      uniqueDesc: 'Dar uma música personalizada significa dar uma emoção. Uma memória que ouvimos, compartilhamos e amamos por anos.'
    },
    faq: {
      title: 'Perguntas Frequentes',
      q1: 'Minhas informações pessoais estão protegidas?',
      a1: 'Absolutamente. O respeito à sua privacidade é uma prioridade. Todas as informações que você compartilha são estritamente confidenciais e usadas apenas para criar sua música personalizada.',
      q2: 'Quanto tempo leva para receber minha música personalizada?',
      a2: 'Nossa equipe de artistas se compromete a entregar sua música em menos de 48 horas. Se você escolher uma opção de entrega prioritária, sua música pode estar pronta em 12 ou 24 horas.',
      q3: 'Como receberei minha música?',
      a3: 'Sua música será enviada por e-mail, em formato MP3 de alta qualidade, pronta para ser ouvida, baixada e compartilhada. Se você escolheu a opção de streaming, também estará disponível nas principais plataformas de streaming.',
      q4: 'Posso escolher o estilo musical da minha música?',
      a4: 'Sim, claro. Você pode escolher o estilo musical, o ambiente e o tipo de voz que deseja. Oferecemos uma ampla variedade de gêneros para corresponder melhor ao gosto da pessoa para quem a música é destinada.',
      q5: 'O que acontece se eu não gostar da música?',
      a5: 'Sua satisfação é nossa prioridade. Se a primeira versão da sua música não corresponder completamente às suas expectativas, você se beneficia de revisões incluídas para ajustar o resultado até que lhe convenha. E se, apesar das revisões, nenhuma versão lhe satisfizer, simplesmente procedemos com um reembolso.',
      q6: 'Existe um limite para o número de reproduções da minha música?',
      a6: 'Nenhum limite. Uma vez entregue sua música, ela pertence inteiramente a você. Você pode ouvi-la quantas vezes quiser, guardá-la para sempre e compartilhá-la com seus entes queridos, sem qualquer restrição.'
    },
    newsletter: {
      title: 'Junte-se à Nossa Newsletter Musical',
      description: 'Digite seu e-mail para ficar informado sobre novidades e se beneficiar de ofertas exclusivas.',
      placeholder: 'E-mail',
      button: 'Inscrever-se'
    },
    trustpilot: {
      title: 'Amado por',
      titleHighlight: 'Milhares',
      description: 'Avaliações reais de clientes reais que experimentaram a magia da música personalizada',
      seeAllReviews: 'Ver todas as avaliações em'
    },
    footer: {
      service: 'Atendimento ao Cliente',
      menu: 'Menu',
      info: 'Informações',
      contact: 'Contato por e-mail de segunda a domingo das 9h às 20h para uma resposta rápida!',
      terms: 'Termos e Condições',
      privacy: 'Política de Privacidade',
      refund: 'Política de Devolução e Reembolso',
      legal: 'Avisos Legais'
    }
  }
};
